<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="1" right>呂善安，我們該怎麼辦？</npc>
              <npc :npc-id="0">就到天井看看吧。</npc>
              <npc :npc-id="1" right>他給你什麼？</npc>
              <npc :npc-id="0">是謎題⋯⋯我想要在天井才能解開。</npc>
              <npc :npc-id="1" right>那我們快過去吧！</npc>

              <story-image :src="require(`@/assets/images/pics/第4章_3-1_元清觀.jpg`)" size="lg"></story-image>
              <!-- （圖片：天井＆香爐） -->

              <npc :npc-id="1" right>就是這裡了！謎題怎麼說？</npc>
              <npc :npc-id="0">我看看⋯⋯</npc>

              <!-- <story-image :src="require(`@/assets/images/pics/第4章_3-2_元清觀謎題圖_1.jpg`)" size="lg"></story-image> -->
              <story-image :src="require(`@/assets/images/pics/第4章_3-3_元清觀謎題圖_2.jpg`)" size="lg"></story-image>
              <!-- （謎題圖片） -->

              <npc :npc-id="1" right>東南之神獸，西南之古器，東北之卦象，西北之神獸⋯⋯這是什麼意思？</npc>
              <npc :npc-id="0">原來如此，看來這次還是簡單的謎題呢。</npc>
              <npc :npc-id="1" right>呂善安，你已經知道答案了？</npc>
              <npc :npc-id="0">沒錯，你也解看看吧！答案是四個字，很簡單喔。</npc>
              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>

        <section class="question">
          <div class="container">

            <!-- 要改的內容 -->
            <question-part hint="答案是四個字，並且觀察一下周邊哪裡有類似的形狀？" morehint="謎題對應到的是香爐腳。">
              <p>西之神獸，北之古器，南之卦象，東之神獸。（「☵」對應北方），據此圖所解出的四字為何？</p>
              <!-- <img :src="require(`@/assets/images/pics/第4章_3-2_元清觀謎題圖_1.jpg`)" class="d-block img-fluid my-2" /> -->
              <img :src="require(`@/assets/images/pics/第4章_3-3_元清觀謎題圖_2.jpg`)" class="d-block img-fluid my-2" />
            </question-part>
            <!-- 要改的內容到此 -->

          </div>
        </section>

      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage4_3',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第四章 - 3',
      isQuestion: true,
      stageId: 'sky',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
